import React from "react";
import PageHeader from "./PageHeader";
import PageHeaderVideo from "./PageHeaderVideo";

// Reuse the same type as PageHeader
export type PageHeaderMedia =
   | { type: "video"; src: string; poster?: string }
   | { type: "image"; src: string };

interface Props {
  title?: string;
  media?: PageHeaderMedia;
}

const PageHeaderWithLoader: React.FC<Props> = ({ title, media }) => {
  return (
    <>
      {media?.type === "video" ? (
        <PageHeaderVideo title={title} media={media} />
      ) : (
        <PageHeader title={title} media={media} />
      )}
    </>
  );
};

export default PageHeaderWithLoader; 
